import React from "react";
import PropTypes from "prop-types";

import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormNumberInput from "Common/Custom/FormNumberInput";
import FormTextarea from "Common/Custom/FormTextarea";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

// Static options for selection_status ENUM
const selectionStatusOptions = [
    {
        value: "pending",
        label: "Pending"
    },
    {
        value: "selected",
        label: "Selected"
    },
    {
        value: "rejected",
        label: "Rejected"
    },
];

const AddCandidateInterviewForm = ({
    values,
    errors = {},
    handleChange,
    handleSubmit,
    loading = false,
    fields,
    CandidateOptions = [],
}) => {

    const optionConfig = {
        shortlist_id: {
            list: CandidateOptions,
            valueKey: "shortlist_id",
            labelKey: "candidate_name",
        },
        selection_status: {
            list: selectionStatusOptions,
            valueKey: "value",
            labelKey: "label",
        },
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;

        const updatedValues = {
            ...values,
            [name]: value,
        };

        const totalMarks =
            Number(updatedValues.interview_marks || 0) +
            Number(updatedValues.written_total_marks || 0) +
            Number(updatedValues.mcq_total_marks || 0);

        handleChange(e);

        handleChange({
            target: {
                name: "total_marks",
                value: totalMarks,
            },
        });
    };

    return (
        <PageBody
            onSubmit={handleSubmit}
            headerchildren={<HeadingOne>Create Candidate Interview</HeadingOne>}
        >
            {fields.map((field) => {

                // 🔹 Select
                if (field.type === "select") {
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={getSelectOptions(field.name, optionConfig)}
                            error={errors[field.name]}
                        />
                    );
                }

                // 🔹 Date / DateTime
                if (field.type === "datetime" || field.type === "date") {
                    return (
                        <FormDatePicker
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                            enableTime={field.type === "datetime"}
                            mode={field.type === "datetime" ? "datetime" : "date"}
                            dateFormat={field.type === "datetime" ? "d-m-Y H:i" : "d-m-Y"}
                            disablePast={true}
                        />
                    );
                }

                // 🔹 Number
                if (field.type === "number") {
                    const disable = field.name === "total_marks";
                    return (
                        <FormNumberInput
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            disabled={disable}
                            handleChange={handleChanges}
                            error={errors[field.name]}
                        />
                    );
                }

                // 🔹 Textarea
                if (field.type === "textarea") {
                    return (
                        <FormTextarea
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                        />
                    );
                }

                // 🔹 Default Text Input
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Create"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

AddCandidateInterviewForm.propTypes = {
    values: PropTypes.object.isRequired,
    errors: PropTypes.object,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
        })
    ).isRequired,
    CandidateOptions: PropTypes.array,
};

export default AddCandidateInterviewForm;
